import React, { Component } from "react";
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { withStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Typography, Tabs, Tab } from '@material-ui/core';

import ItemDetails from "../components/ItemDetails";
import PageActionRecommender from '../components/PageActionRecommender';
import { datesAreDiff } from "../utils/datesAreDiff";
import ItemHistory from "../components/ItemHistory";
import ItemHistoryInsights from "../components/ItemHistoryInsights";
import ItemPaths from "../components/ItemPaths";

const premium = process.env.REACT_APP_SKU === "premium";

// TODO: move these conditionals to exports
const runningLocal = process.env.REACT_APP_API_DOMAIN !== "sc";
const PathService = runningLocal ?
                        require("../data/PathService.dev").default :
                        require("../data/PathService.prod").default;
                        

const PageMetricsService = runningLocal ?
                        require("../data/PageMetricsService.dev").default :
                        require("../data/PageMetricsService.prod").default;

const ItemService = runningLocal ?
                        require("../data/ItemService.dev").default :
                        require("../data/ItemService.prod").default;

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '1350px'
  },
});

function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

class PageDetail extends React.Component {

  state = {
    value: 0,
    analytics: null,
    content: null,
    paths: null,
    loading: true
  };

  shouldComponentUpdate(nextProps, nextState) {
    const update =
      this.state.analytics !== nextState.analytics ||
      this.state.content !== nextState.content ||
      this.state.paths !== nextState.paths ||
      this.state.value !== nextState.value ||
      datesAreDiff(this.props.dateRange.start, nextProps.dateRange.start) ||
      datesAreDiff(this.props.dateRange.end, nextProps.dateRange.end);
    return update;
  }

  componentDidMount() {
    this.update(this.props.match.params.pageid, this.props.match.params.pageIdHash);
  }

  componentDidUpdate(prevProps) {
    const datesChanged =
      datesAreDiff(this.props.dateRange.start, prevProps.dateRange.start) ||
      datesAreDiff(this.props.dateRange.end, prevProps.dateRange.end);

    const itemIdChanged =
      prevProps.match.params.pageid !== this.props.match.params.pageid;

    if (datesChanged && itemIdChanged) {
      //if the item id chagnes then the pageid hash much change with it.
      this.update(this.props.match.params.pageid, this.props.match.params.pageIdHash);
    } else if (datesChanged) {
      this.update();
    }
  }

  update(itemId, pageIdHash) {
    const dateRange = this.props.dateRange;
    const promises = [
      PageMetricsService.getPageMetrics(
        itemId,
        pageIdHash,
        dateRange.start,
        dateRange.end
      ),
      PageMetricsService.getPageVisitHistory(
        itemId,
        pageIdHash,
        dateRange.start,
        dateRange.end
      ),
      PathService.getItemPaths(itemId, dateRange.start, dateRange.end)
    ];

    if (itemId) {
      promises.push(ItemService.getItemData(itemId));
      promises.push(ItemService.getItemVersionHistory(itemId))
    }

    Promise.all(promises).then(values => {
      console.log("TODO: need to merge history and metrics");

      if (values[0] === null) {
        throw `Data is corrupted.  Could not find record for page id hash [${pageIdHash}]`
      }
      let pageMetrics = values[0].data.content[0];
      let pageVisitHistory = values[1].data.content;
      let paths = values[2] === undefined ? null : values[2];
      let item = values[3] === undefined ? null : values[3];
      let itemVersionHistory = values[4] === undefined ? null : values[4];
      let recommendations = PageActionRecommender.getRecommendations(pageMetrics, item);

      this.setState({
        loading: false,
        analytics: pageMetrics,
        pageVisitHistory: pageVisitHistory,
        pageVersionHistory: itemVersionHistory,
        paths: paths,
        content: item,
        recommendations: recommendations
      });
    });
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  render() {

    if (this.state.loading) {
      return null;
    }

    const { classes, theme } = this.props;
    return (
      <div className={classes.root}>
        <AppBar position="static" color="default" style={{width: '96%'}}>
          <Toolbar>
            <Typography variant="title" color="inherit">
              {this.state.content.name} ({this.state.content.path})
            </Typography>
          </Toolbar>
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            fullWidth
          >
            <Tab label="Key insights" />
            <Tab label="History" />
            <Tab label="Paths" />
            {premium ? <Tab label="Historical Insights"/> : <Tab label="Historical Insights 🔒" disabled />}
            {premium ? <Tab label="Audience"/> : <Tab label="Audience 🔒" disabled />}
            {premium ? <Tab label="SEO"/> : <Tab label="SEO 🔒" disabled />}
            {premium ? <Tab label="Performance"/> : <Tab label="Performance 🔒" disabled />}
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={this.state.value}
        
          style={{width: '96%'}}
        >
          <TabContainer dir={theme.direction}>
            <ItemDetails {...this.state} />
          </TabContainer>
          <TabContainer dir={theme.direction}>
            <ItemHistory {...this.state} />
          </TabContainer>
          <TabContainer dir={theme.direction}>
            <ItemPaths {...this.state} pageId={this.props.match.params.pageid} />
          </TabContainer>
          <TabContainer dir={theme.direction}>
            <ItemHistoryInsights {...this.state} />
          </TabContainer>
          <TabContainer dir={theme.direction}>
            <h2>Audience</h2>
          </TabContainer>
          <TabContainer dir={theme.direction}>
            <h2>SEO</h2>
          </TabContainer>
          <TabContainer dir={theme.direction}>
            <h2>Performance</h2>
          </TabContainer>
          </SwipeableViews>
      </div>
    );
  }
}

PageDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(PageDetail);



// WEBPACK FOOTER //
// ./src/containers/PageDetail.js